<template>
    <section>
        <div class="line-item-container" :class="{ 'hide-table': hideTable }">
            <div :class="{'table': !recurring}">
                <div
                    v-for="itemGroup in sortedLineItemGroups"
                    :key="`frequency-${itemGroup.frequency}`"
                    :data-qa="`recurring-table-${itemGroup.frequency}`"
                    class="frequency-group"
                >
                    <div v-if="recurring" class="frequency-header">
                        {{ $t(`InvoiceLineItems.frequencyHeader.${itemGroup.frequency}`) }}
                    </div>

                    <InvoiceLineItemHeader :invoice="invoice" :narrow-element="narrowElement" />

                    <InvoiceLineItem
                        v-for="item in itemGroup.lineItems"
                        :key="item.id"
                        :item="item"
                        :invoice="invoice"
                        :contact="invoice.contact.firstName"
                        :narrow-element="narrowElement"
                        :recurring="recurring"
                        :paid-invoice="paidInvoice"
                        class="line-item-product"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import InvoiceLineItem from './InvoiceLineItem.vue';
import InvoiceLineItemHeader from './InvoiceLineItemHeader.vue';

export default {
    components: {
        InvoiceLineItem,
        InvoiceLineItemHeader,
    },

    props: {
        invoice: Object,
        narrowElement: Boolean,
        paidInvoice: Boolean,
        recurringInvoice: Boolean,
        companyProfile: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            sortedLineItemGroups: [],
        };
    },

    computed: {
        filteredOrderItems() {
            let filteredOrderItems = this.invoice.orderItems?.filter(({ type }) => type !== 'Tax') || [];

            if (this.invoice.discount?.lineItemId) {
                filteredOrderItems = filteredOrderItems.filter(({ id }) => id !== this.invoice.discount.lineItemId);
            }

            return filteredOrderItems;
        },

        hideTable() {
            return !this.invoice.orderItems?.length;
        },

        recurring() {
            return this.invoice.orderItems?.some(({ recurringBilling }) => recurringBilling === true);
        },
    },

    created() {
        this.onCreated();
    },

    methods: {
        onCreated() {
            this.sortByRecurringFrequency();
        },

        async sortByRecurringFrequency() {
            this.sortedLineItemGroups = [];

            if (!this.recurring) {
                this.sortedLineItemGroups = [{
                    frequency: 0,
                    lineItems: this.filteredOrderItems,
                }];

                return;
            }

            await this.filteredOrderItems.forEach((item) => {
                const arrayPosition = this.sortedLineItemGroups.findIndex((obj) => obj.frequency === item.billingCycle);

                if (arrayPosition === -1) {
                    this.sortedLineItemGroups.push({
                        frequency: item.billingCycle,
                        lineItems: [item],
                    });
                } else {
                    this.sortedLineItemGroups[arrayPosition].lineItems.push(item);
                }
            });

            this.sortedLineItemGroups.sort((a, b) => b.frequency - a.frequency);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.line-item-container {
    padding: $spacing-300 $spacing-400;

    @media screen and (max-width: 800px) {
        margin-bottom: 0;
    }
}

.hide-table {
    padding: 0 $spacing-400;

    .table {
        display: none;
    }

    @media($medium) {
        height: 0;
        border: 0;
    }
}

.line-item-product {
    padding: $spacing-200 0;
    border-top: 1px solid $color-gray-200;

    &:last-child {
        border-bottom: 1px solid $color-gray-200;
    }
}

.frequency-header {
    font-size: $font-size-md;
    padding-bottom: $spacing-200;
    font-weight: $font-weight-bold;
}

.frequency-group {
    margin: $spacing-200 $spacing-100;

    @media($small) {
        margin: $spacing-200 0;
    }

    &:not(:first-child) {
        margin-top: $spacing-600;
    }
}

@media only screen and ($small) {
    .line-item-container {
        padding: $spacing-200;
        margin: 0;
    }

    .line-item-product {
        margin: 0;
        padding: $spacing-100 0;
    }
}

@media print {
    .line-item-product {
        margin: 0;
        padding: 0;
    }
}
</style>
